import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchOrderLinesPaginated,
  fetchOrderLinesPaginatedGrouped,
  fetchProcessingOrderLinesPaginated,
} from "../../api/orders";
import {
  SaleOrdersGroupedDataType,
  SaleOrdersPaginatedDataType,
} from "../../components/catalog/types";

export type initialStateType = {
  isLinesLoading: boolean;
  linesData: SaleOrdersPaginatedDataType | undefined;
  processingLinesData: SaleOrdersPaginatedDataType | undefined;
  groupedLinesData: SaleOrdersGroupedDataType | undefined;
};

export type fetchOrdersLinesParamsType = {
  pageNum: number;
  isReserve: boolean;
  isPreOrder?: boolean;
  isOwn?: boolean;
  searchValue?: string;
  activeFilters?: any;
  operator?: string;
};

const initialState: initialStateType = {
  linesData: undefined,
  processingLinesData: undefined,
  groupedLinesData: undefined,
  isLinesLoading: true,
};

let currentLinesRequestId = 0;
let currentGroupedRequestId = 0;
let currentProcessingRequestId = 0;

export const fetchLines = createAsyncThunk(
  "slice/fetchLines",
  async (values: fetchOrdersLinesParamsType) => {
    const requestId = ++currentLinesRequestId;
    const result = await fetchOrderLinesPaginated(values);
    if (requestId === currentLinesRequestId) {
      return result.data?.data;
    }
  },
);

export const fetchGroupedLines = createAsyncThunk(
  "slice/fetchGroupedLines",
  async (values: fetchOrdersLinesParamsType) => {
    const requestId = ++currentGroupedRequestId;
    const result = await fetchOrderLinesPaginatedGrouped(values);
    if (requestId === currentGroupedRequestId) {
      return result.data?.data;
    }
  },
);

export const fetchProcessingLines = createAsyncThunk(
  "slice/fetchProcessingLines",
  async (values: fetchOrdersLinesParamsType) => {
    const requestId = ++currentProcessingRequestId;
    const result = await fetchProcessingOrderLinesPaginated(values);
    if (requestId === currentProcessingRequestId) {
      return result.data?.data;
    }
  },
);

export const resetLines = createAsyncThunk(
  "slice/createAsyncThunk",
  async () => initialState,
);

const reservationLinesSliceReducer = createSlice({
  name: "reservationLines",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLines.fulfilled, (state, action) => {
        if (action.payload) {
          state.linesData = action.payload;
        }
        state.isLinesLoading = false;
      })
      .addCase(fetchGroupedLines.fulfilled, (state, action) => {
        if (action.payload) {
          state.groupedLinesData = action.payload;
        }
        state.isLinesLoading = false;
      })
      .addCase(fetchProcessingLines.fulfilled, (state, action) => {
        if (action.payload) {
          state.processingLinesData = action.payload;
        }
        state.isLinesLoading = false;
      })
      .addCase(resetLines.fulfilled, (state, action) => {
        Object.assign(state, initialState);
        state.isLinesLoading = false;
      })
      .addCase(fetchLines.pending, (state, action) => {
        state.isLinesLoading = true;
      })
      .addCase(fetchGroupedLines.pending, (state, action) => {
        state.isLinesLoading = true;
      })
      .addCase(fetchProcessingLines.pending, (state, action) => {
        state.isLinesLoading = true;
      });
  },
});

export default reservationLinesSliceReducer.reducer;
